export class OperationalExpenseModel {
  lightFleetExpense: number = 0;
  mobileCommunicationExpense: number = 0;
  administrativeExpense: number = 0;
  totalOperationalExpense: number = 0;
}
